import React, { useState, ReactElement, useCallback } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Spinner } from 'react-bootstrap';
import routes from '../../utils/routes';

type FavoritesProps = {
    listing: Listing
}

type Listing = {
    id: number,
    isFavorited: boolean,
    type: string
}

const Favorite: React.FC <FavoritesProps> = ({
  listing,
}): ReactElement => {
  const {
    id,
    isFavorited,
    type,
  } = listing;

  const [isFavorite, setIsFavorite] = useState(isFavorited);
  const [loading, setLoading] = useState(false);

  const favoriteChange = useCallback(() => {
    const endpoint = isFavorite
      ? routes.apiUnfavoritePost(type, id)
      : routes.apiFavoritePost(type, id);
    setLoading(true);

    axios.post(endpoint)
      .then(() => {
        const message = isFavorite
          ? 'Listing removed from favorites'
          : 'Listing added to favorites';
        Swal.fire(
          'Success!',
          message,
          'success',
        ).then(() => {
          setLoading(false);
          setIsFavorite(!isFavorite);
        });
      })
      .catch((error) => {
        if (error.response.status === 401) {
          Swal.fire(
            'Error',
            'Please log in to favorite!',
            'error',
          )
            .then(() => setLoading(false));
        } else {
          Swal.fire(
            'Error',
            'Please try again.',
            'error',
          )
            .then(() => setLoading(false));
        }
      });
  }, [isFavorite, listing]);

  if (!id || !type) {
    return <></>;
  }

  if (loading) {
    return (
      <Spinner animation="grow" variant="primary" />
    );
  }

  return (
    <button
      className="btn btn-outline p-0"
      onClick={() => favoriteChange()}
    >
      <span className={`h5 ${isFavorite ? 'icon-heart text-blue-500' : 'icon-heart-outline text-blue-gray'}`} />
    </button>
  );
};

export default Favorite;

if (document.getElementsByClassName('favorite-heart-toggle')) {
  document.querySelectorAll('.favorite-heart-toggle').forEach((singleElement) => {
    const listingid = singleElement.getAttribute('data-listing-id');
    const listingfav = !!(singleElement.getAttribute('data-listing-fav'));
    const listingtype = String(singleElement.getAttribute('data-listing-type'));
    const listing: Listing = {
      id: listingid ? parseInt(listingid, 10) : 0,
      isFavorited: !!listingfav,
      type: listingtype || '',
    };
    ReactDOM.render(<Favorite listing={listing} />, singleElement);
  });
}
